import { Injectable } from "@angular/core";
import { CanMatch, Route, UrlSegment } from "@angular/router";

import { UserRoleSelector } from "#interfaces/user/enums/user-role-selector-enum";

@Injectable({ providedIn: "root" })
export class SalesAdvisorGuard implements CanMatch {
  canMatch(_route: Route, _segments: UrlSegment[]): boolean {
    return localStorage.getItem("rol") === UserRoleSelector.SalesAdvisor;
  }
}
